export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_EMAIL_SMTP(state, smtp) {
    state.smtp = smtp;
  },
  ADD_EMAIL_SMTP(state, smtp) {
    state.smtp.push(smtp);
  },
  UPDATE_EMAIL_SMTP(state, smtp) {
    const certIndex = state.smtp.findIndex(
      e => e.host === smtp.host
    );
    Object.assign(state.smtp[certIndex], smtp);
  },
  DELETE_EMAIL_SMTP(state, host) {
    const certIndex = state.smtp.findIndex(u => u.host === host);
    state.smtps.splice(certIndex, 1);
  }
};
